import { Component, Input, OnInit } from "@angular/core";
import { PictureService } from "src/app/_services/picture.service";
import { RelatedItem } from "src/app/api/models/related-item";

@Component({
    selector: "app-item-preview-related-items",
    templateUrl: "./related-items.component.html",
    styleUrls: ["./related-items.component.scss"],
    standalone: false
})
export class ItemPreviewRelatedItemsComponent implements OnInit {
  @Input() relatedItems: RelatedItem[];
  constructor(public pictureService: PictureService) {}

  ngOnInit(): void {}
}
